<template>
  <calc-form-item title-style="inline">
    <template slot="title">
      {{ $t("Fibra inferior") }}
      <app-tooltip class="m-pad-0">
        <img
          style="width: 300px"
          src="@/assets/img/fibra_superior_e_inferior.jpg"
        />
      </app-tooltip>
    </template>

    <b-checkbox v-model="useLowerFibre"
      >{{ $t("Número de travamentos laterais") }}

      <app-tooltip v-if="showTooltip" class="m-width-m">{{
        $t(
          "É aconselhável a aplicação, por vão, do número de travamentos indicado"
        )
      }}</app-tooltip>
    </b-checkbox>

    <transition name="anim-slideX">
      <calc-form-unit-fibre-span-cfg
        ref="calcFormUnitFibreSpanCfg"
        v-if="useLowerFibre"
        v-model="lowerFibre"
      />
    </transition>
  </calc-form-item>
</template>

<script>
import { mapState } from "vuex";
import { withoutDuplicates } from "@/utils";
import CalcFormUnitFibreSpanCfg from "./CalcFormUnitFibreSpanCfg";

export default {
  components: {
    CalcFormUnitFibreSpanCfg,
  },

  data() {
    return {
      unwatchUseLowerFibre: undefined,
      useLowerFibre: undefined,
    };
  },

  computed: {
    ...mapState("calculator", ["calculation"]),

    lowerFibre: {
      get() {
        return this.calculation.input.spanRestraints.lowerFibre;
      },
      set(val) {
        this.calculation.input.spanRestraints.lowerFibre = val;
      },
    },

    showTooltip() {
      const { type, direction, format } = this.calculation.input;
      return (
        type === 2 && (direction === 1 || (direction === 2 && format === 2))
      );
    },
  },

  activated() {
    if (this.useLowerFibre !== true) {
      const { type, direction, format } = this.calculation.input;
      const isSpecialCase = type === 2 && direction === 2 && format === 2;

      this.useLowerFibre =
        !(
          withoutDuplicates(this.lowerFibre).length === 1 &&
          this.lowerFibre[0] === 0
        ) || isSpecialCase;
    }

    //we only want to start watching after we set it's initial value from watch(lowerfibre)
    this.unwatchUseLowerFibre = this.$watch("useLowerFibre", () => {
      this.lowerFibre = Array(this.lowerFibre.length).fill(0);
    });
  },

  deactivated() {
    this.unwatchUseLowerFibre();
  },
};
</script>
